import { createContext } from 'react';

import {
  PolicyAuditReportInput,
  PolicyAuditReportRecord,
  PolicyAuditReportResult,
} from '@totem/components/surveyV2/policyAuditReport/types';

interface Context {
  input: PolicyAuditReportInput;
  setInput: (input: PolicyAuditReportInput) => void;
  loading: boolean;
  data: PolicyAuditReportResult;
  action: string;
  actionItem: PolicyAuditReportRecord;
  onAction?: (action: string, actionItem: PolicyAuditReportRecord) => void;
}

export default createContext<Context>({
  input: {},
  setInput: () => {},
  loading: false,
  data: null,
  action: '',
  actionItem: null,
  onAction: () => {},
});
